import { VdsButton } from '@volt/volt-extended-components-react';
import styles from './ColourButton.module.scss';
import classNames from 'classnames';

type VdsButtonProps = React.ComponentProps<typeof VdsButton>;
interface ColourButtonProps {
  colour: string;
  patternImageUrl?: string;
  makeTransparent?: boolean;
  onClick?: VdsButtonProps['onClick'];
  opacity?: number;
  height?: number;
}

const applyOpacityToHexColour = (colour: string, opacity = 100): string => {
  // Remove '#' if present
  const cleanHex = colour.replace('#', '');

  // Convert opacity (0–100) to hex (00–FF)
  const alpha = Math.round((opacity / 100) * 255);
  const alphaHex = alpha.toString(16).padStart(2, '0').toUpperCase();

  // Return 8-digit hex
  return `#${cleanHex}${alphaHex}`;
};

export const ColourButton = ({
  colour,
  patternImageUrl = '',
  makeTransparent = false,
  onClick,
  opacity,
  height,
}: ColourButtonProps) => {
  const effectiveColour = makeTransparent
    ? 'transparent'
    : applyOpacityToHexColour(colour, opacity ?? 100);
  const patternStyle = patternImageUrl && !makeTransparent ? `url(${patternImageUrl})` : 'none';
  const buttonHeight = height ? `${height}px` : 'auto';

  return (
    <VdsButton
      className={classNames(
        styles.colourButton,
        !onClick && styles.noPointer,
        patternImageUrl && styles.patternImageUrl,
        height && styles.height,
      )}
      style={{
        '--color-background-brand-default': effectiveColour,
        '--color-background-brand-hover': effectiveColour,
        '--color-background-brand-press': effectiveColour,
        '--color-interaction-brand-lowest': effectiveColour,
        '--color-link-hover': effectiveColour,
        '--color-border-brand-hover': 'transparent',
        '--color-button-pattern-image-url': patternStyle,
        '--color-button-height': buttonHeight,
      }}
      isFullWidth
      variant={'ghost'}
      onClick={onClick}
    />
  );
};

export default ColourButton;
